import styled from "styled-components";

export const TitleContainer = styled.div`
  align-items: baseline;
`;

export const SubTitleContainer = styled.div`
  align-items: baseline;
  justify-content: space-between;
  display: flex;
  margin-top: 30px;
  margin-bottom: 1rem;
`;

export const InfoContainer = styled.div``;
